// Where the warranty start date comes from: `default_source` on the purchase
// template's `warranty_start_date` field. Issuance reads the same setting.

type SourceAttribute = {
  code_name: string
  configuration_data?: Record<string, unknown> | null
}

/** The field the start date defaults from, or null when the user enters it. */
export function warrantyStartSource(
  attrs: readonly SourceAttribute[] | undefined,
): string | null {
  const raw = attrs?.find((a) => a.code_name === 'warranty_start_date')
    ?.configuration_data?.default_source
  if (typeof raw !== 'string') return null
  const source = raw.trim()
  return source && source !== 'warranty_start_date' ? source : null
}

/** The source's value: the purchase date on this step, or a field captured earlier. */
export function warrantyStartDefault(
  source: string | null,
  purchaseDate: unknown,
  earlyAttributes: Record<string, unknown> | undefined,
): string | null {
  const value =
    source === 'purchase_date'
      ? purchaseDate
      : source
        ? earlyAttributes?.[source]
        : null
  return typeof value === 'string' && value.trim() ? value.trim() : null
}

/** A start date follows a purchase change unless it is a later date the user chose. */
export function startFollowsPurchase(
  start: string,
  previousPurchase: string,
  nextPurchase: string,
): boolean {
  return !start || start === previousPurchase || start < nextPurchase
}
